import React, { Component } from 'react';
import { Divider, Header } from 'semantic-ui-react';
import ListSubscribers from './ListSubscribers';
import NewSubcriber from './NewSubscriber';

class Subscribers extends Component {
  state = {
    resultsPage: '1',
    pageTokens: {
      1: null,
    },
  };

  setResultsPage = (page, nextToken) => {
    let newPageTokens = this.state.pageTokens;
    if (nextToken) {
      newPageTokens = {
        ...newPageTokens,
        [page]: nextToken,
      };
    }

    this.setState({
      resultsPage: page,
      pageTokens: newPageTokens,
    });
  };

  render() {
    return (
      <div>
        <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
          Administration
        </Header>
        <NewSubcriber
          mode={'admin'}
          page={this.state.resultsPage}
          pageTokens={this.state.pageTokens}
          setResultsPage={this.setResultsPage.bind(this)}
          history={this.props.history}
        />
        <Divider style={{ padding: '1em' }} />
        <ListSubscribers
          page={this.state.resultsPage}
          history={this.props.history}
          setResultsPage={this.setResultsPage.bind(this)}
          pageTokens={this.state.pageTokens}
        />
      </div>
    );
  }
}

export default Subscribers;



// WEBPACK FOOTER //
// ./src/components/Subscribers.js